import React, {Component} from 'react';
import Auth, {Permission} from '../../utils/auth';

import SelectRegion from './components/SelectRegion';
import ListOrders from './components/ListOrders';
import {RouteComponentProps, withRouter} from 'react-router';

class OrdersHistoryPage extends Component<RouteComponentProps> {
  grantPermission(regionId: string, type: Permission): boolean {
    const roles: Array<string> = Auth.getRoles();
    const regionRoles = roles.filter(role => role.includes('regionRole'));
    const requiredRoles = regionRoles.filter(role => role.includes(type)).map(role => role.split(':')[1]);

    if (roles.some(role => role === 'admin')) {
      return true;
    }

    return requiredRoles.some(allowedRegion => allowedRegion === regionId);
  }

  getPath() {
    return window.location.pathname.substr(1).split('/');
  }

  getScene() {
    const path = this.getPath();

    if (path[1] && !this.grantPermission(path[1], Permission.Orders)) {
      this.props.history.push('/error/authorization');
      return <div />;
    }

    if (path[1]) {
      return <ListOrders regionId={path[1]} />;
    }

    return <SelectRegion />;
  }

  render() {
    return this.getScene();
  }
}

export default withRouter(OrdersHistoryPage);



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/SubmissionCrmErrorsPage.tsx